import React, { useCallback, useMemo, useState } from "react";
import { Slate, Editable, withReact } from "slate-react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import MarkButton from "./plugins/MarkButton";
import BlockButton from "./plugins/BlockButton";
import { Toolbar } from "./plugins/Toolbar";
import Element from "./plugins/Element";
import {
  Bold_Logo,
  Italic_Logo,
  Underline_Logo,
  Code_Logo,
  Heading1_Logo,
  Heading2_Logo,
  Unordered_List_Logo,
  Ordered_List_Logo,
  Left_Align_Logo,
  Center_Align_Logo,
  Right_Align_Logo,
  Justify_Align_Logo
} from "./plugins/Icons";


export const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
};

const TextField = ({ formik, id, placeholder, ...props }) => {
  const editor = useMemo(() => withHistory(withReact(createEditor())), []);
  
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);
  const renderElement = useCallback((props) => <Element {...props} />, []);
  const [value, setValue] = useState([])
  const initialValue = [
    {
      type: "paragraph",
      children: [{ text: placeholder ? `${placeholder}` : '' }],
    },
  ];

  const content = (values) => {
    const isAtChange = editor.operations.some((op)=>'set_selection' !== op.type);
    if(isAtChange) {
      formik.setFieldValue(id,JSON.stringify(values));
    } 
  }

  let minHeight = ( props.minHeight )  ? props.minHeight : 350;
  let editableClass = ( props.editableClass )  ? props.editableClass : '';

  return (
    <div>
      <Slate 
        editor={editor} 
        value={initialValue} 
        onChange={value => content(value)}
        >
        <Editable
          className={`form-control h-auto ${editableClass}`}
          style={{minHeight: minHeight}}
          renderLeaf={renderLeaf}
          renderElement={renderElement}
        />
      </Slate>
    </div>
  );
};

export default TextField;
